import React from 'react';
import { get, isEmpty } from 'lodash';

// React view component to render
import { memberManagementEligibilityHistory as MemberManagementEligibilityHistoryView } from 'ui/views/widgets/memberManagementEligibilityHistory';
import { MemberManagementEligibilityHistoryService } from 'services/memberManagementEligibilityHistory';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberManagementEligibilityHistory } from 'ui/containers/MemberManagementEligibilityHistory';
 *
 * // render
 * <MemberManagementEligibilityHistory propName='propValue'/>
 */
export class MemberManagementEligibilityHistory extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        this.fetchGeneration = 0;
        this.fetchActive = true;

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

         // Member Detail instance
         this.memberManagementEligibilityHistoryService = new MemberManagementEligibilityHistoryService();

         // start member detail data fetch
         this.fetchComponentData();
    }

    async fetchComponentData( ) {
        log.debug( 'MemberManagementEligibilityHistory.fetchComponentData()' );

        const generation = ++this.fetchGeneration;
        // cancel ongoing request
        this.memberManagementEligibilityHistoryService.cancel();

        // fetch component data
        const { status, data } = await this.memberManagementEligibilityHistoryService.fetchComponentData( {
            url: this.props.widget.url,
            data: this.props.requestPayload
        } );

        if( ! this.fetchActive || generation !== this.fetchGeneration ) return;

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            if( ! isEmpty( get( data, 'description', {} ) ) ) {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    showCustomErrorView: true,
                    componentData: data

                    // networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } ) : null );
            } else {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } ) : null );
            }
        } else {

            this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data
            } ) : null );
        }
    }

    /**
     * @desc When component unmounts, cleanup resources.
     */
    componentWillUnmount() {
        this.fetchActive = false;
        this.fetchGeneration++;
        this.memberManagementEligibilityHistoryService.cancel(); // cancel ongoing requests
    }


    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberManagementEligibilityHistoryView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} )}
            />
        );
    }
}

// set display name
MemberManagementEligibilityHistory.displayName = 'MemberManagementEligibilityHistory';

// set default props
MemberManagementEligibilityHistory.defaultProps = {};

// prop types
MemberManagementEligibilityHistory.propTypes = {};
